import { createContext, useState } from "react";

export const DrivingLicenseClassContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [drivingLicenseClasses, setDrivingLicenseClasses] = useState([]);

    // Make the context object:
    const drivingLicenseClassContext = {
        drivingLicenseClasses,
        setDrivingLicenseClasses,
    };

    // pass the value in provider and return
    return <DrivingLicenseClassContext.Provider value={drivingLicenseClassContext}>{children}</DrivingLicenseClassContext.Provider>;
};

export const { Consumer } = DrivingLicenseClassContext;
